import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export enum RoutesIds {
  segments = 'segments',
  segment = 'segment',
}

// Internal route refs (used by this plugin's routable extension)
export const segmentsRouteImplRef = createRouteRef({
  id: RoutesIds.segments,
});
export const rootRouteRef = segmentsRouteImplRef;

export const segmentRouteImplRef = createSubRouteRef({
  id: RoutesIds.segment,
  parent: rootRouteRef,
  path: '/:id',
});

// External route refs (used by other plugins/apps to bind)
export const segmentsRouteRef = createExternalRouteRef({
  id: RoutesIds.segments,
});
export const segmentRouteRef = createExternalRouteRef({
  id: RoutesIds.segment,
  params: ['id'],
});

export const Routes = {
  segments: segmentsRouteImplRef,
  segment: segmentRouteImplRef,
} satisfies Record<RoutesIds, RouteRef | SubRouteRef>;

export const ExternalRoutes = {
  segments: segmentsRouteRef,
  segment: segmentRouteRef,
} satisfies Record<RoutesIds, ExternalRouteRef>;
